import Head from "@helper/seo/head";
import React from "react";
import Layout from "@/landing/template/term";
import getContents from "@helper/util/landing/getContents";

function Landing() {
  const { contents } = getContents();
  return (
    <>
      <Head
        title="SellOn | Term & Conditions"
        catchme=""
      />
      <Layout contents={contents} />
    </>
  );
}

export default Landing;
